// Teller Online Files
import { PublicHelpTag } from 'apps/public-portal/src/app/shared/help/help-tags';
import { helpTitle } from 'apps/public-portal/src/app/shared/help/help-titles';

// Teller Online Library Files
import { HelpArticle, HelpConditional } from 'teller-online-libraries/help';

export const CHECKOUT_HELP_ARTICLES: HelpArticle[] = [
    new HelpArticle({
        tag: PublicHelpTag.Checkout,
        order: 7,
        bookmark: 'zip-code-does-not-match',
        title: helpTitle('zip-code-does-not-match'),
        body: '<p>If you are receiving this message at checkout, the payment processor is '
            + 'indicating the zip code you have entered does not match the address that your '
            + 'card issuer has on file.</p>'
            + '<p>We recommend you double check the value you are entering is correct and '
            + 'confirm that your card issuer has the correct address.</p>'
    }),
    new HelpArticle({
        tag: PublicHelpTag.Checkout,
        order: 8,
        conditions: [HelpConditional.NotRedirect],
        bookmark: 'credit-card-rejected',
        title: helpTitle('credit-card-rejected'),
        body: 'There are multiple reasons your credit card could be rejected. Please confirm the '
            + 'following:'
            + '<ul>'
            + '<li>You are entering the name that appears on the credit card.</li>'
            + '<li>You are entering the correct credit card number, expiry date, and CVV.</li>'
            + '<li>You are entering the correct zip code that your credit card issuer has on '
            + 'file for your credit card.</li>'
            + '</ul>'
    }),
    new HelpArticle({
        tag: PublicHelpTag.Checkout,
        order: 12,
        bookmark: 'how-do-i-pay',
        title: helpTitle('how-do-i-pay'),
        body: '<p>Open your cart if it\'s not currently open by clicking on the cart button '
            + '(:shopping_cart:) in the header at the top of the page.</p> '
            + '|condition:Redirect||condition:Users|<p>If you are not signed in, there is a field '
            + 'at the bottom of the cart panel for you to provide an email, which is required so a '
            + 'receipt can be emailed to you.</p>'
            + '<p>If you are signed in, or after you have input an email address, you can click '
            + '<b>Checkout</b> to proceed.</p>|endcondition:Users|'
            + '|condition:NotUsers|<p>There is a field at the bottom of the cart panel for you to '
            + 'provide an email, which is required so a receipt can be emailed to you.</p>'
            + '<p>After you have input an email address, you can click <b>Checkout</b> to '
            + 'proceed.</p>|endcondition:NotUsers||endcondition:Redirect|'
            + '|condition:NotRedirect|<p>At '
            + 'the bottom of the cart panel there is a <b>Checkout</b> button which will take you '
            + 'to the checkout page.</p>'
            + '<p>Once there, you can choose how you would like to pay, enter your payment '
            + 'details, and click the <b>Pay</b> button at the '
            + 'bottom.</p>|endcondition:NotRedirect|'
    })
];
